import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { PageHeader, Badge, EmptyState } from "../components/Brand";
import { useApp, API } from "../AppContext";

const fmt = (n) => new Intl.NumberFormat("fr-CA", { style: "currency", currency: "CAD" }).format(n || 0);

export default function QuotesList() {
  const { t } = useApp();
  const [quotes, setQuotes] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    axios.get(`${API}/quotes`).then(({ data }) => setQuotes(data));
  }, []);

  return (
    <div>
      <PageHeader title={t.quotes.title}
        action={<button className="btn-red" onClick={() => nav("/app/quotes/new")} data-testid="new-quote-btn"><Plus size={16} /> {t.quotes.new}</button>} />
      {quotes.length === 0 ? (
        <EmptyState title={t.quotes.empty} icon={<Plus size={24} color="#D4AF37" />} />
      ) : (
        <div className="glass-card overflow-x-auto">
          <table className="w-full text-sm" data-testid="quotes-table">
            <thead>
              <tr className="text-left uppercase text-xs tracking-wider" style={{ color: "rgba(245,245,245,0.5)" }}>
                <th className="p-4">{t.quotes.number}</th><th>{t.quotes.client}</th><th>{t.quotes.project}</th>
                <th>{t.quotes.total}</th><th>{t.quotes.status}</th><th>{t.quotes.date}</th><th></th>
              </tr>
            </thead>
            <tbody>
              {quotes.map((q) => (
                <tr key={q.id} className="border-t hover:bg-white/[0.02]" style={{ borderColor: "rgba(245,245,245,0.05)" }}>
                  <td className="p-4 font-mono text-xs" style={{ color: "#D4AF37" }}>{q.quote_number}</td>
                  <td>{q.client_name}</td>
                  <td className="max-w-xs truncate">{q.project_name}</td>
                  <td className="font-semibold">{fmt(q.total)}</td>
                  <td><Badge status={q.status} label={t.status[q.status] || q.status} /></td>
                  <td className="text-xs" style={{ color: "rgba(245,245,245,0.55)" }}>{(q.date || "").slice(0, 10)}</td>
                  <td><Link to={`/app/quotes/${q.id}`} className="btn-ghost text-xs py-1.5 px-3" data-testid={`view-${q.id}`}>→</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
